var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-loader-spinner"},[_c('svg',{staticClass:"loading-spinner"},_vm._l((_vm.circles),function(item,index){return _c('circle',{key:index,attrs:{"cx":_vm.circlePositions[index] && _vm.circlePositions[index].x,"cy":_vm.circlePositions[index] && _vm.circlePositions[index].y,"r":item.radius,"fill":item.color}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }